module.exports = __webpack_public_path__ + "static/promo-preview-ac8c9562f382731cbd5a696ab949b1c0.mp4";